export const COMPANIES_SEARCH_ATOM = 'home/COMPANIES_SEARCH_ATOM';
export const COMPANIES_SEARCH_REFRESH_ATOM =
  'home/COMPANIES_SEARCH_REFRESH_ATOM';
export const COMPANIES_SEARCH_SELECTOR = 'home/COMPANIES_SEARCH_SELECTOR';
export const COMPANIES_PROFILE_REFRESH_ATOM =
  'home/COMPANIES_PROFILE_REFRESH_ATOM';
export const COMPANIES_PROFILE_SELECTOR = 'home/COMPANIES_PROFILE_SELECTOR';
